import { render } from "./index.vue?vue&type=template&id=f0eb2eea&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=f0eb2eea&scoped=true&lang=less"

import exportComponent from "D:\\web\\my\\水茶花\\sch-h5\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f0eb2eea"]])

export default __exports__